import { render, staticRenderFns } from "./ViewMesas.vue?vue&type=template&id=e8d00676&scoped=true&"
import script from "./ViewMesas.vue?vue&type=script&lang=js&"
export * from "./ViewMesas.vue?vue&type=script&lang=js&"
import style0 from "./ViewMesas.vue?vue&type=style&index=0&id=e8d00676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d00676",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardText,VCol,VDivider,VIcon,VImg,VRow,VScrollYTransition})
